// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2k-x-","dragIcon":"SortableItem_dragIcon__3sWFs","disabled":"SortableItem_disabled__1Sj3o"};